const MONTHS = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function eventDate(e: {
  eventYear: number;
  eventMonth?: number | null;
  eventDate?: string | null;
  datePrecision: string;
}): string {
  if (e.datePrecision === 'day' && e.eventDate) {
    return new Date(`${e.eventDate}T00:00:00`).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  if (e.eventMonth) return `${MONTHS[e.eventMonth]} ${e.eventYear}`;
  return String(e.eventYear);
}

export const PHASE_LABEL: Record<string, string> = {
  setup: 'Setup',
  scoring_open: 'Scoring open',
  scoring_closed: 'Scoring closed',
  revealing: 'Revealing',
  final: 'Final',
};

export const STATUS_LABEL: Record<string, string> = {
  upcoming: 'Upcoming',
  live: 'Live',
  completed: 'Completed',
  archived: 'Archived',
};

/** 1 → "1st", 2 → "2nd", 11 → "11th", 23 → "23rd". */
export function ordinal(n: number): string {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${['th', 'st', 'nd', 'rd'][n % 10] ?? 'th'}`;
}

/** A group score for display: "56.5", or "—" when there isn't one (yet). */
export function points(score: number | null | undefined): string {
  if (score == null || !Number.isFinite(Number(score))) return '—';
  return Number(score).toLocaleString(undefined, { maximumFractionDigits: 2 });
}
